export default {
  feedback: {
    success: 'Mobile App saved successfully',
    error: 'Failed to save Mobile App',
  },
};
